import React from 'react';
import './AddFile.css';
import Select from 'react-select';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCheckbox} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function AddFileView(props) {
  const handleCheckboxChange = (event) => {
    props.handleChantierCheckBox();
  };

  return (
    <div className="banktable-container">
      <MDBContainer fluid >
        <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
          <MDBCol col="12">
            <MDBCard className="bg-dark text-white my-2 mx-auto align-items-center"
              style={{borderRadius: '1rem', maxWidth: '800px'}}>
              <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>Ajouter un PDF</h2>
              <MDBCardBody className="mx-auto w-100 addInfo-padding">
                <div className="app" style={{textAlign: 'left', marginTop: '10px'}}>
                  <label className="text-white">PDF</label>
                  <div>
                    <input
                      name="file"
                      type="file"
                      accept="application/pdf"
                      onChange={props.handleFileChange}
                      className="form-control" />
                  </div>
                </div>
                {props.errors && props.errors.file && (
                  <span className="error">{props.errors.file}</span>
                )}
                <div className="form-group">
                  <input
                    type="text"
                    name="nomFichier"
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Nom du PDF" />
                </div>

                <div className="app" style={{textAlign: 'center', marginTop: '25px'}}>
                  <label className="text-white">
                    Voir tous les projets ?
                  </label>
                  <div className="folder-toggle-switch" style={{marginBottom: '5px'}}>
                    <div>
                      <input
                        id="toggle"
                        type="checkbox"
                        checked={props.checkedChantier}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="toggle"></label>
                    </div>
                  </div>
                </div>
                <Select
                  name="chantiers"
                  isMulti
                  options={props.placeName}
                  className="form-control addcheckin-form-control-padding"
                  placeholder="Liste des projets"
                  value={props.form.chantier}
                  onChange={props.handleChantierChange}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: '20px',
                      width: '100%',
                    }),
                  }} />
                {props.errors && props.errors.chantier && (
                  <span className="error">{props.errors.chantier}</span>
                )}
                <div style={{marginTop: '28px'}}>
                  <input
                    className="form-control"
                    type="date"
                    name="selectedDate"
                    defaultValue={props.form.selectedDate}
                    onChange={props.handleChangeValue}
                    style={{
                      fontSize: '18px',
                      color: 'black',
                      fontWeight: '450',
                    }} />
                </div>
                <div style={{marginTop: '22px'}}>
                  <MDBCheckbox name='extra1' id='folder-inlineCheckbox11111' label='Extra possible' onChange={props.handleChangeCheckbox} inline />
                  {localStorage.getItem('admin') === '1' ?
                  <React.Fragment>
                    <MDBCheckbox name='extra2' id='folder-inlineCheckbox22222' label='Extra valider' onChange={props.handleChangeCheckbox} inline />
                    <MDBCheckbox name='extra3' id='folder-inlineCheckbox33333' label='Extra confirmer' onChange={props.handleChangeCheckbox} inline />
                  </React.Fragment> : '' }
                </div>
                {localStorage.getItem('admin') === '1' ?
                <div className="app" style={{textAlign: 'center', marginTop: '25px'}}>
                  <label className="labelFacture">PDF Privé ?</label>
                  <div className="toggle-switch" style={{marginBottom: '5px'}}>
                    <div>
                      <input
                        id="toggle2"
                        name="prive"
                        type="checkbox"
                        onChange={props.handleChangeCheckbox} />
                      <label htmlFor="toggle2"></label>
                    </div>
                  </div>
                </div> : ''}

                <div className="form-group">
                  <textarea
                    type="text"
                    name="note"
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Note" />
                </div>
                <Button
                  color="white"
                  size="lg"
                  style={{
                    color: 'white',
                    fontSize: 'calc(10px + 2vmin)',
                    backgroundColor: '#363E46',
                    border: 'none',
                    width: '100%',
                    marginTop: '15px',
                  }}
                  onClick={props.handleSubmit}>
                  Enregistrer
                </Button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default AddFileView;
